export const daysOffsetOptions = [
  { label: 'No selection', value: null },
  { label: '30 Days', value: 30 },
  { label: '60 Days', value: 60 },
  { label: '90 Days', value: 90 },
  { label: '120 Days', value: 120 },
  { label: '240 Days', value: 240 },
  { label: 'Average days in program', value: 'avgProgramDays' },
];

export const maxMonthOptions = [
  { label: 'No selection', value: null },
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];
